import { useQuery } from '@tanstack/react-query';

import getRoleAccess from 'Api/role/getRoleAccess';

import getRoleAccessResponse from './model/response/getRoleAccessResponse';

const useGetRoleAccess = () =>
  useQuery({
    queryKey: ['role-access'],
    queryFn: async () => {
      const response = await getRoleAccess();

      const result = getRoleAccessResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });

export default useGetRoleAccess;
